'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = require('decisiv-ui-utils');

var _decisivIconixReact = require('decisiv-iconix-react');

var _decisivIconixReact2 = _interopRequireDefault(_decisivIconixReact);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  display: flex;\n\n  button:first-child {\n    border-radius: ' + theme.dimensions.borderRadius + ' 0 0 ' + theme.dimensions.borderRadius + ';\n  }\n\n  button:not(:last-child) {\n    border-right: transparent;\n  }\n\n  button:last-child {\n    border-radius: 0 ' + theme.dimensions.borderRadius + ' ' + theme.dimensions.borderRadius + ' 0;\n  }\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var ButtonGroup = (0, _decisivUiUtils.buildStyledComponent)('ButtonGroup', _styledComponents2.default.div, styles, {
  themePropTypes: themePropTypes
});

ButtonGroup.Button = _Button2.default;
ButtonGroup.ButtonIcon = _decisivIconixReact2.default;

exports.default = ButtonGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/ButtonGroup/index.js
// module id = 1542
// module chunks = 2